import { render, staticRenderFns } from "./GerenciaCadastroContratos.vue?vue&type=template&id=1f3830d2"
import script from "./GerenciaCadastroContratos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports